module.exports = __webpack_public_path__ + "static/media/masters_thesis21.582eae4d.webp";